import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { compose } from 'utils/react';
import { Row, Section } from 'components';
import globalClasses from 'theme/facility-globals.scss';
import { BUILDER } from 'shared/abilities';
import { section, stylesModal } from '../decorators';

const TwoColumnHeaderRight = ({ children, sectionStyle = {} }) => {
  const [left, header, right, Carousel] = React.Children.toArray(children);

  return (
    <Section
      className={globalClasses.section}
      Carousel={Carousel}
      {...sectionStyle}
    >
      <Row verticalAlign="md">
        <Col md={6} sm={12}>
          {left}
        </Col>
        <Col md={6} sm={12}>
          <div>{header}</div>
          <div>{right}</div>
        </Col>
      </Row>
    </Section>
  );
};
TwoColumnHeaderRight.propTypes = {
  children: PropTypes.node.isRequired,
  sectionStyle: PropTypes.object,
};

const component = compose(
  stylesModal(),
  section(
    { name: '2 Column: Text Header (right)', category: 'Content Layout' },
    {
      subsections: [
        {
          accepts: [
            'ContentBox',
            'Coupon',
            'DirectionsText',
            'FacilityInformation',
            'MapboxMapAllFacilities',
            'MapboxMapOneFacility',
            'HeaderText',
            'Hours',
            'Image',
            'ImageGrid',
            'ReviewStars',
            'Accordion',
          ],
        },
        { accepts: ['Button', 'HeaderText', 'Accordion'] },
        {
          accepts: [
            'ContentBox',
            'Coupon',
            'DirectionsText',
            'FacilityInformation',
            'Hours',
            'Accordion',
          ],
        },
        { accepts: ['Carousel'] },
      ],
      defaults: [
        'MapboxMapAllFacilities',
        'HeaderText',
        'ContentBox',
        'Carousel',
      ],
      menu: { items: ['edit', 'delete'] },
    },
  ),
)(TwoColumnHeaderRight);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
